@if (corporateTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    <div formArrayName="voeging">
      @for (item of voeging.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control
              [label]="i === 0 ? 'Naam gevoegde dochter' : ''"
              [required]="true"
              class="custom-input-250"
              formControlName="naamDochtervennootschap"
              id="naamDochtervennootschap-{{i}}"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-button
              (click)="showDialog(i)"
              [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
              icon="plus"
              type="secondary"
            >Meer gegevens
            </snelstart-ui-button>
            <snelstart-ui-button
              (click)="verwijderRij(i)"
              [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
              icon="trash"
              iconType="light"
              id="buttonDelete-{{i}}"
              size="medium"
              type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
  </form>

  <snelstart-ui-button
    (click)="addRij()"
    class="snelstart-ui-button pb-3"
    icon="plus"
    id="cancel"
    type="link"
  >Vennootschap toevoegen
  </snelstart-ui-button>

  <snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="voegingSpec" size="lg"
                                  title="Gegevens voeging dochtermaatschappij">
    <snelstart-ui-dialog-header-content>
      Vul onderstaande informatie in op het tjdstip onmiddellijk voorafgaand aan de voeging van de dochtermaatschappij.
    </snelstart-ui-dialog-header-content>
    <snelstart-ui-dialog-body>
      <div style="max-width: 90%">
        <form [formGroup]="formGroup">
          <div formArrayName="voeging">
            @for (item of voeging.controls; track item; let i = $index) {
              <div [formGroupName]="i">
                @if (i === index) {
                  @if (voeging.controls[i]; as rowControl) {
                    <div class="row">
                      <div class="col col-1">
                        <p>Waardering schuld aan moeder op balans dochter</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [required]=true
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-150"
                          formControlName="waarderingSchuldBalansDochter"
                          id="waarderingSchuldBalansDochter-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Waardering vordering op dochter op balans moeder</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-150"
                          formControlName="waarderingVorderingBalansAndereMaatschappij"
                          id="waarderingVorderingBalansAndereMaatschappij-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    <div>
                      <div class="row">
                        <div class="col col-1">
                          <p>Belaste vrijval schuld bij gevoegde dochter</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-number-form-control
                            [showAllDecimals]="false"
                            align="right"
                            class="custom-input-150"
                            formControlName="belasteVrijvalSchuldBijDochter"
                            id="belasteVrijvalSchuldBijDochter-{{i}}"
                            prefix="€"
                          >
                          </snelstart-ui-number-form-control>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Waardering vordering die dochter had op moeder</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [required]=true
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-150"
                          formControlName="waarderingVorderingOpBalansDochter"
                          id="waarderingVorderingOpBalansDochter-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Waardering corresponderende schuld van moeder aan dochter</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-150"
                          formControlName="waarderingSchuldOpBalansAndereMaatschappij"
                          id="waarderingSchuldOpBalansAndereMaatschappij-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    <div>
                      <div class="row">
                        <div class="col col-1">
                          <p>Belaste vrijval schuld bij moeder</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-number-form-control
                            [showAllDecimals]="false"
                            align="right"
                            class="custom-input-150"
                            formControlName="belasteVrijvalSchuldAndereMaatschappij"
                            id="belasteVrijvalSchuldAndereMaatschappij-{{i}}"
                            prefix="€"
                          >
                          </snelstart-ui-number-form-control>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Waarde economisch verkeer van de gevoegde deelneming</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-150"
                          formControlName="wevDeelnemingInDochter"
                          id="wevDeelnemingInDochter-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Fiscale boekwaarde van de gevoegde deelneming op de balans van de moeder</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-150"
                          formControlName="boekwaardeDeelnemingInDochter"
                          id="boekwaardeDeelnemingInDochter-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Fiscaal eigen vermogen van de gevoegde dochter</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-150"
                          formControlName="fiscaalVermogenDochter"
                          id="fiscaalVermogenDochter-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Herwaardering van de dochter door de moeder</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-150"
                          formControlName="herwaarderingDochterDoorMoeder"
                          id="herwaarderingDochterDoorMoeder-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Vermogenssprong bij de moeder als gevolg van voeging</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-150"
                          formControlName="vermogenssprongMoederBijVoeging"
                          id="vermogenssprongMoederBijVoeging-{{i}}"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>
                  }
                }
              </div>
            }
          </div>
        </form>
      </div>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
      <snelstart-ui-button class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
      <snelstart-ui-button icon="check" id="save" type="primary">
        Akkoord
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}
